import {useState} from 'react';
import {MapViewContext, TileCoord} from "../contexts/MapViewContext";
import FeedSidebar from "../components/FeedSidebar";
import MapboxMapComponent from "../components/MapboxMapComponent";
import {useParams} from "react-router-dom";
import {LngLatBounds} from "mapbox-gl";

const MapboxMapWithId: React.FC = () => {
    const {mapId} = useParams<{ mapId: string }>();
    const [mapTileCoords, setMapTileCoords] = useState<TileCoord[]>([]);
    const [viewportBounds, setViewportBounds] = useState<LngLatBounds>(null);
    const [hoveredStateId, setHoveredStateId] = useState<string | null>(null);
    const [mapName, setMapName] = useState<string | null>(null);
    const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState<string[]>([]);
    const [searchQuery, setSearchQuery] = useState<string | null>(null);
    const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);

    return (
        <MapViewContext.Provider
            value={{
                mapTileCoords,
                setMapTileCoords,
                viewportBounds,
                setViewportBounds,
                hoveredStateId,
                setHoveredStateId,
                mapName,
                setMapName,
                selectedTagIds,
                setSelectedTagIds,
                selectedCategoryIds,
                setSelectedCategoryIds,
                searchQuery,
                setSearchQuery,
                sidebarCollapsed,
                setSidebarCollapsed,
            }}>
            <div style={{display: 'flex', height: '100vh'}}>
                <FeedSidebar mapId={mapId}/>
                <div style={{flex: 1}}>
                    <MapboxMapComponent mapId={mapId}/>
                </div>
            </div>
        </MapViewContext.Provider>
    );
};

export default MapboxMapWithId;
